module.exports = __webpack_public_path__ + "img/IMG_8629_T_L_Foamcore.12c4542a.jpg";